/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import MomSysOrderPurchaseDetailPurMaterialRegisterButton from "../input/MomSysOrderPurchaseDetailPurMaterialRegisterButton";
import MomSysOrderPurchaseDetailPur2GoodsRegisterButton from "../input/MomSysOrderPurchaseDetailPur2GoodsRegisterButton";
import MomSysOrderPurchaseDetailPstMaterialRegisterButton from "../input/MomSysOrderPurchaseDetailPstMaterialRegisterButton";
import MomSysOrderBuyerPurchaseDetailUpdateButton from "../input/MomSysOrderBuyerPurchaseDetailUpdateButton";
import DeleteSingleRecordButton from "../input/DeleteSingleRecordButton";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import SaveToExcelButton from "../input/SaveToExcelButton";

function MomSysUglOrderPurchaseDetail(props) {
    const { orderPurchaseMstSelect, onUpdateMaster, onDetailEmpty } = props;

    const id = "MomSysUglOrderPurchaseDetail";
    const table = "MomSysUglOrderPurchaseDetail";
    const view = "MomSysZvwOrderPurchaseDetail";

    const { t } = useTranslation();

    const [orderPurchaseDetailSchema, setOrderPurchaseDetailSchema] = useState();

    const [orderPurchaseDetailGrid, setOrderPurchaseDetailGrid] = useState();
    const [orderPurchaseDetailApi, setOrderPurchaseDetailApi] = useState();
    const [orderPurchaseDetailDataEmpty, setOrderPurchaseDetailDataEmpty] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setOrderPurchaseDetailSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (orderPurchaseDetailApi) {
            orderPurchaseDetailApi.refresh();
        }
    }, [orderPurchaseMstSelect.orderPurchaseId]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifySuccess = (msg) => {
        notifySuccess(msg);

        if (orderPurchaseDetailApi) {
            orderPurchaseDetailApi.refresh();
        }

        if (onUpdateMaster) {
            onUpdateMaster();
        }
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onPartialFailure = (msg) => {
        notifyWarning(msg);

        if (orderPurchaseDetailApi) {
            orderPurchaseDetailApi.refresh();
        }

        if (onUpdateMaster) {
            onUpdateMaster();
        }
    };

    const onModifyUrl = (url, orderPurchaseId) => {
        return url + "/" + orderPurchaseId;
    };

    const onDialogUpdateDetail = () => {
        if (orderPurchaseDetailApi) {
            orderPurchaseDetailApi.refresh();
        }

        if (onUpdateMaster) {
            onUpdateMaster();
        }
    };

    const doHandleBackendErrorMsg = (reason) => {
        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;
    };

    const onAppendButtonInFrontOfSearch = () => {
        return (
            <BasicCrudScreenActionItemLayout>
                <AccessControl
                    accessTarget={orderPurchaseDetailSchema && orderPurchaseDetailSchema.name}
                    accessMethod="POST"
                >
                    <MomSysOrderPurchaseDetailPurMaterialRegisterButton
                        id={id}
                        schema={orderPurchaseDetailSchema}
                        disabled={orderPurchaseMstSelect.approvalState}
                        onSuccess={onNotifySuccess}
                        onDialogUpdateDetail={onDialogUpdateDetail}
                        orderPurchaseMstSelect={orderPurchaseMstSelect}
                        customizeErrorMsgCallback={doHandleBackendErrorMsg}
                    />

                    <MomSysOrderPurchaseDetailPur2GoodsRegisterButton
                        id={id}
                        schema={orderPurchaseDetailSchema}
                        disabled={orderPurchaseMstSelect.approvalState}
                        onSuccess={onNotifySuccess}
                        onDialogUpdateDetail={onDialogUpdateDetail}
                        orderPurchaseMstSelect={orderPurchaseMstSelect}
                        customizeErrorMsgCallback={doHandleBackendErrorMsg}
                    />

                    <MomSysOrderPurchaseDetailPstMaterialRegisterButton
                        id={id}
                        schema={orderPurchaseDetailSchema}
                        disabled={orderPurchaseMstSelect.approvalState}
                        onSuccess={onNotifySuccess}
                        onDialogUpdateDetail={onDialogUpdateDetail}
                        orderPurchaseMstSelect={orderPurchaseMstSelect}
                        customizeErrorMsgCallback={doHandleBackendErrorMsg}
                    />
                </AccessControl>

                <AccessControl
                    accessTarget={orderPurchaseDetailSchema && orderPurchaseDetailSchema.name}
                    accessMethod={
                        orderPurchaseDetailSchema && (orderPurchaseDetailSchema.updateWithPatch ? "PATCH" : "PUT")
                    }
                >
                    <MomSysOrderBuyerPurchaseDetailUpdateButton
                        id={id}
                        schema={orderPurchaseDetailSchema}
                        grid={orderPurchaseDetailGrid}
                        disabled={orderPurchaseMstSelect.approvalState || orderPurchaseDetailDataEmpty}
                        //disabled={orderPurchaseDetailDataEmpty}
                        onSuccess={onNotifySuccess}
                        customizeErrorMsgCallback={doHandleBackendErrorMsg}
                    />
                </AccessControl>

                <AccessControl
                    accessTarget={orderPurchaseDetailSchema && orderPurchaseDetailSchema.name}
                    accessMethod="DELETE"
                >
                    <DeleteSingleRecordButton
                        id={id}
                        schema={orderPurchaseDetailSchema}
                        grid={orderPurchaseDetailGrid}
                        makeItemName={(row) => {
                            return `${t("columnName.orderPurchaseDetailId")}: ${row.orderPurchaseDetailId}`;
                        }}
                        color="secondary"
                        disabled={orderPurchaseMstSelect.approvalState || orderPurchaseDetailDataEmpty}
                        //disabled={orderPurchaseDetailDataEmpty}
                        onSuccess={onNotifySuccess}
                        onFailure={onFailure}
                    />
                </AccessControl>

                <AccessControl
                    accessTarget={orderPurchaseDetailSchema && orderPurchaseDetailSchema.name}
                    accessMethod="SAVETOEXCEL"
                >
                    <SaveToExcelButton
                        id={id}
                        grid={orderPurchaseDetailGrid}
                        view={view}
                        color="primary"
                        disabled={orderPurchaseDetailDataEmpty}
                    />
                </AccessControl>
            </BasicCrudScreenActionItemLayout>
        );
    };

    return (
        <BasicCrudScreenType
            headerTitle={t("term.poDetail")}
            id={id}
            table={table}
            view={view}
            onModifyViewUrl={(url) => onModifyUrl(url, orderPurchaseMstSelect.orderPurchaseId)}
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setOrderPurchaseDetailGrid(grid);
            }}
            onApiInitialized={(api) => {
                setOrderPurchaseDetailApi(api);
            }}
            onLoadData={(data) => {
                onDetailEmpty(data.length < 1 ? true : false);
                setOrderPurchaseDetailDataEmpty(data.length < 1 ? true : false);
            }}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
}

export default MomSysUglOrderPurchaseDetail;
